var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"center"}},[_c('h4',[_vm._v("Delete ASN Map")])]),_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"center","align-v":"center"}},[_vm._v(" Are you sure you want to delete "+_vm._s(_vm.AsnMap.displayName)+"? ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }